import { Box, Flex } from '@joinrepublic/dls-ui-kit';

import { useAnalytics } from '@r-client/shared/data/analytics';
import {
  Box as LegacyBox,
  Button,
  Text,
  Tooltip,
} from '@r-client/shared/ui/core';
import { InfoGray, SvgIconLight, Warning } from '@r-client/shared/ui/icons';

import styles from './identity-verification-banner.module.scss';

export const IdentityVerificationBanner = () => {
  const analytics = useAnalytics();

  const viewAndConfirmHandler = () => {
    analytics.track({
      name: 'website_banner_clicked',
      params: {
        banner_name: 'IdentityVerificationBanner',
        button_name: 'view_and_confirm',
      },
    });
  };
  return (
    <Flex
      justifyContent="space-between"
      alignItems={{ lg: 'center', sm: 'flex-start' }}
      direction={{ sm: 'column' }}
      py="6"
      px="4"
      bg="gray-f2"
      className={styles.actionWrapper}
    >
      <Flex mb={{ sm: '4' }} m={{ lg: 'auto' }}>
        <Text bold color="error">
          <SvgIconLight icon={Warning} />
        </Text>
        <Flex m="0 0 0 6px" display={{ base: 'none', sm: 'flex' }}>
          <Text bold color="error">
            Action required
          </Text>
        </Flex>
        <LegacyBox m="0 0 0 6px">
          Updated identity information is needed for your investments.
          <Tooltip
            content="Our records show that certain personal information you provided is no longer up to date.
              Please re-verify your personal information to ensure a seamless experience with respect
              to your existing investments."
          >
            <SvgIconLight
              dataTestId="identity-verification-tooltip"
              icon={InfoGray}
              className={styles.infoIcon}
            />
          </Tooltip>
        </LegacyBox>
      </Flex>
      <Box alignSelf="stretch" textAlign="center">
        {/* TODO: Button will launch Cognito flow modal. Currently should ONLY show on investment pages needing identity verification, but might change user journey (pending conversation with design) */}
        <Button
          type="default-thin"
          href="/portfolio"
          className={styles.action}
          onClick={viewAndConfirmHandler}
        >
          Verify now
        </Button>
      </Box>
    </Flex>
  );
};
